export default function SVGDishwasher(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="7" y="57" width="50" height="50" rx="2" transform="rotate(-90 7 57)" stroke="#757575" strokeWidth="2" />
            <path
                d="M50.1111 15C50.1111 16.7182 48.7182 18.1111 47 18.1111C45.2818 18.1111 43.8889 16.7182 43.8889 15C43.8889 13.2818 45.2818 11.8889 47 11.8889C48.7182 11.8889 50.1111 13.2818 50.1111 15Z"
                stroke="#757575"
                strokeWidth="1.77778"
            />
            <path d="M56 23L8 23" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M56 48L8 48" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="28" cy="39" r="9" stroke="#757575" strokeWidth="2" />
            <path
                d="M33 31.204C34.2748 30.4383 35.7548 30 37.3333 30C42.1198 30 46 34.0294 46 39C46 43.9706 42.1198 48 37.3333 48C35.7548 48 34.2748 47.5617 33 46.796"
                stroke="#757575"
                strokeWidth="2"
            />
        </svg>
    );
}
